import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Inspections } from 'pages/assetDatabase/assetOverview/Inspections'

export const Route = createFileRoute('/inspections/{-$siteID}')({
  component: InspectionsRouteComponent,
  staticData: {
    title: 'Inspections',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})

function InspectionsRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <Inspections />
}
